module.exports = __webpack_public_path__ + "media/frontend/components/footer/logo-a-25b1ad8883e2151cc0b85d3d580db419.png";